import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import PageHero from '../components/PageHero'
import BookingForm from '../components/BookingForm'
import ScrollReveal from '../components/ScrollReveal'
import { business, services } from '../data/siteData'
import './Booking.css'

export default function Booking() {
  return (
    <>
      <SEO
        title="Book Your Event | AS Elite Gatherings — Marthandam, Tamil Nadu"
        description="Book weddings, corporate events, product launches, private parties or stage decoration with AS Elite Gatherings. Call +91 63822 82058 or submit the booking form."
        keywords="book event Marthandam, wedding booking Tamil Nadu, event booking form, corporate event enquiry Marthandam, party booking Kanniyakumari"
        path="/booking"
      />
      <PageHero
        eyebrow="Book Your Event"
        title="Let's start planning"
        text={
          <>
            Share a few details about your event and our team will follow up with a plan
            and a quote — usually within one business day. Not sure yet? Browse our{' '}
            <Link to="/services">full services list</Link> or{' '}
            <Link to="/gallery">see past events</Link> first.
          </>
        }
        image="/images/bg/bg8.webp"
      />

      <section className="section">
        <div className="container booking-layout">
          <ScrollReveal direction="left">
            <BookingForm />
          </ScrollReveal>

          <ScrollReveal direction="right" delay={100} className="booking-aside">
            <div className="booking-aside-card">
              <h3>What Happens Next</h3>
              <ol>
                <li>We review your enquiry and check date availability.</li>
                <li>You'll get a call or email to talk through the vision and budget.</li>
                <li>We share a concept and quote for your event.</li>
                <li>On confirmation, we start building — décor, staging and run-of-show.</li>
              </ol>
            </div>

            <div className="booking-aside-card">
              <h3>We Plan For</h3>
              <ul className="booking-services-list">
                {services.map((s) => (
                  <li key={s.id}>
                    <Link to={`/services#${s.id}`}>{s.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="booking-aside-card booking-aside-contact">
              <h3>Prefer to Talk Directly?</h3>
              <a href={business.phoneHref}>{business.phone}</a>
              <a href={`mailto:${business.email}`}>{business.email}</a>
              <p>{business.addressOneLine}</p>
            </div>
          </ScrollReveal>
        </div>
      </section>
    </>
  )
}
